import { createVanIconComponent } from "./van"

const EcardPay = createVanIconComponent("ecard-pay")
export default EcardPay
